<script>
export default {
  props: {
    modeEdit: {
      type: String,
      default: 'cell'
    },
    model: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      required: true
    },
    allowDel: {
      type: Boolean,
      default: false
    },
    allowAdd: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    },
    editOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dataSource: {
      get () {
        return this.model
      },
      set (val) {
        this.model = val
        this.$emit('change', val)
      }
    },
    editing () {
      console.log('edit options', this.editOptions)
      let opt = JSON.parse(JSON.stringify(this.editOptions))
      console.log('depois edit options')
      opt.mode = this.modeEdit
      opt.allowUpdating = true
      opt.allowDeleting = this.allowDel
      opt.allowAdding = this.allowAdd
      opt.useIcons = true
      return opt
    }
  },
  methods: {
    add (item) {
      if (typeof item === 'object' && Object.keys(item).length > 0) this.dataSource.push(item)
    }
  }
}
</script>

<template>
  <dx-data-grid
    class="formGrid"
    :show-column-headers="header"
    :data-source="dataSource"
    :columns="columns"
    :show-borders="true"
    :editing="editing" />
</template>

<style scoped>
  .formGrid {
    margin-top: 5px
  }
  .btn-acoes .dx-button {
    margin-left: 5px;
  }
</style>
<style>
  .formGrid .dx-datagrid-header-panel {
    height: 34px !important;
  }
  .formGrid .dx-toolbar-text-auto-hide .dx-button .dx-button-content {
    padding: 3px 5px 7px !important;
  }
</style>
